import DashboardFiltersMobile from './DashboardFiltersMobile';

export default DashboardFiltersMobile;
